// @flow

import * as React from 'react';
import styled from 'styled-components';
import {
  Checkmark,
  Plus,
  Minus,
  Expand,
  Collapse,
  Close,
  Padlock,
  Phone,
  Watch,
  Adviser,
  Document,
  Documents,
  Chat,
  BookMeeting,
  Information,
  Error,
  Warning,
  MitIdApp,
  MitIdCode,
  MitIdReader,
} from './svg';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const CheckmarkIcon = () => (
  <IconContainer>
    <Checkmark width="0.875em" height="0.750em" />
  </IconContainer>
);

export const PlusIcon = () => (
  <IconContainer>
    <Plus width="1.5em" height="1.5em" />
  </IconContainer>
);

export const MinusIcon = () => (
  <IconContainer>
    <Minus width="1.25em" height="1.25em" />
  </IconContainer>
);

export const ExpandIcon = () => (
  <IconContainer>
    <Expand width="1.25em" height="1.25em" />
  </IconContainer>
);

export const CollapseIcon = () => (
  <IconContainer>
    <Collapse width="1.25em" height="1.25em" />
  </IconContainer>
);

export const CloseIcon = () => (
  <IconContainer>
    <Close width="0.75em" height="0.75em" />
  </IconContainer>
);

export const PadlockIcon = () => (
  <IconContainer>
    <Padlock width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const PhoneIcon = () => (
  <IconContainer>
    <Phone width="1.5rem" height="1.5rem" color="#003755" />
  </IconContainer>
);

export const WatchIcon = () => (
  <IconContainer>
    <Watch width="1rem" height="1rem" color="#003F63" />
  </IconContainer>
);

export const AdviserIcon = () => (
  <IconContainer>
    <Adviser width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const DocumentIcon = ({ width, height }: Props) => (
  <DynamicIconContainer>
    <Document width={width} height={height} />
  </DynamicIconContainer>
);

export const DocumentsIcon = ({ width, height, color }: Props) => (
  <DynamicIconContainer>
    <Documents width={width} height={height} color={color} />
  </DynamicIconContainer>
);

export const ChatIcon = () => (
  <IconContainer>
    <Chat width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const BookMeetingIcon = () => (
  <IconContainer>
    <BookMeeting width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const InformationIcon = () => (
  <IconContainer>
    <Information width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const ErrorIcon = ({
  width = '1.5rem',
  height = '1.5rem',
  color,
}: Props) => (
  <DynamicIconContainer>
    <Error width={width} height={height} color={color} />
  </DynamicIconContainer>
);

export const WarningIcon = () => (
  <IconContainer>
    <Warning width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const MitIdAppIcon = () => (
  <IconContainer>
    <MitIdApp width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const MitIdReaderIcon = () => (
  <IconContainer>
    <MitIdReader width="1.5rem" height="1.5rem" />
  </IconContainer>
);

export const MitIdCodeIcon = () => (
  <IconContainer>
    <MitIdCode width="1.5rem" height="1.5rem" />
  </IconContainer>
);

const IconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
`;

const DynamicIconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
`;
